/**
 * @file 多个号码手机预览图
 * @author
 */

import React, {useState} from 'react';
import phoneCall from '../../asset/img/userCenter/d20_telephone_outlined.png';
import dianhua from '../../asset/img/userCenter/dianhua1.jpeg';

import {DownOutlined, UpOutlined} from '@ant-design/icons';

export default function MultiPhonePreview(props: any) {
    const {phones, name, iconSrc} = props;

    const [showMore, setShowMore] = useState(false);
    const renderTitle = () => {
        return name?.length ? name + '电话' : '企业对外展示名称';
    };
    const tempIcon = iconSrc
        ? iconSrc
        : 'https://sjwsops.baidu.com/ops/dianhua/20210712/a069fd57c91ec14ecad2e4414b692b38.png';
    const sectionStyle = {
        width: '100%',
        height: '40px',
        backgroundRadius: 0,
        backgroundSize: 'contain',
        backgroundPosition: 'right',
        position: 'static',
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url(' + tempIcon + ')'
    };
    const phoneList = () => {
        return phones.map((item, index) => {
            if (index === 0) {
                return (
                    <div className="phone-item" key={item + index}>
                        <div className="phone-list c-span11">
                            <div className="phone-num">
                                {phones[0]?.value?.length ? phones[0].value : '认证号码'}
                                {phones[0]?.extensionP?.length ? `转${phones[0].extensionP}` : ''}
                            </div>
                            {phones[0]?.telName?.length ? (
                                <div className="phone-title">{phones[0].telName}</div>
                            ) : (
                                <div className="phone-title">认证号码标签</div>
                            )}
                        </div>
                        <div className="phone-icon">
                            <img src={phoneCall} alt="tel" />
                        </div>
                    </div>
                );
            }
            if (index > 4 && !showMore) {
                return null;
            }
            return (
                <div className="phone-item" key={item + index}>
                    <div className="phone-list c-span11">
                        <div className="phone-num">
                            {item.extensionP ? `${item?.value}转${item.extensionP}` : item?.value}
                        </div>
                        <div className="phone-title">{item?.telName}</div>
                    </div>
                    <div className="phone-icon">
                        <img src={phoneCall} alt="tel" />
                    </div>
                </div>
            );
        });
    };
    return (
        <div className="multi-phone-preview">
            <div className="transform-phone">
                <div className="top-banner">
                    <div className="left-title">
                        <div className="top-title">{renderTitle()}</div>
                        <div className="top-tip">
                            <span>以下号码经</span>
                            <div className="label">百度安全认证</div>
                        </div>
                    </div>
                    <div className="right-logo">
                        <div className="logo-img-src">
                            <div style={sectionStyle}></div>
                        </div>
                    </div>
                </div>
                <div className="phone-content">
                    <div className="phone-content-list">{phoneList()}</div>
                    {phones.length > 5 && (
                        <div
                            className="l-mod3"
                            onClick={() => {
                                setShowMore(!showMore);
                            }}
                        >
                            <span style={{marginRight: '7px'}}>{!showMore ? '展开' : '收起'}</span>
                            {!showMore ? <DownOutlined /> : <UpOutlined />}
                        </div>
                    )}
                    <div className="slink-list">
                        <div className="slink-item">号码报错</div>
                        <div className="slink-item">认证我的企业</div>
                    </div>
                    <div className="card-source">
                        <img
                            src={dianhua}
                            alt=""
                        />
                        <span>百度安全号码认证平台</span>
                        <span className="right-back">...</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
